import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import { useTranslate, useUserLanguage } from '@mui/docs/i18n';
import { HighlightedCodeWithTabs } from '@mui/docs/HighlightedCodeWithTabs';
import { MarkdownElement } from '@mui/docs/MarkdownElement';
import Demo from 'docs/src/modules/components/Demo';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function noComponent(moduleID) {
  return function NoComponent() {
    throw new Error("No demo component provided for '".concat(moduleID, "'"));
  };
}
export default function RichMarkdownElement(props) {
  var _demoComponents$demo$, _demoComponents$demo$2, _demoComponents$demo$3, _demoComponents$demo$4, _demoComponents$demo$5, _demoComponents$demo$6;
  var activeTab = props.activeTab,
    demoComponents = props.demoComponents,
    _props$demos = props.demos,
    demos = _props$demos === void 0 ? {} : _props$demos,
    disableAd = props.disableAd,
    localizedDoc = props.localizedDoc,
    renderedMarkdownOrDemo = props.renderedMarkdownOrDemo,
    srcComponents = props.srcComponents;
  var userLanguage = useUserLanguage();
  var t = useTranslate();
  if (typeof renderedMarkdownOrDemo === 'string') {
    return /*#__PURE__*/_jsx(MarkdownElement, {
      renderedMarkdown: renderedMarkdownOrDemo
    });
  }
  if (renderedMarkdownOrDemo.component) {
    var _name = renderedMarkdownOrDemo.component;
    var Component = srcComponents == null ? void 0 : srcComponents[_name];
    if (Component === undefined) {
      throw new Error("No component found at the path 'docs/src/".concat(_name));
    }
    var additionalProps = {};
    if (_name === 'modules/components/ComponentPageTabs.js') {
      additionalProps.activeTab = activeTab;
    }
    return /*#__PURE__*/_jsx(Component, _extends({}, renderedMarkdownOrDemo, additionalProps, {
      markdown: localizedDoc
    }));
  }
  if (renderedMarkdownOrDemo.type === 'codeblock') {
    return /*#__PURE__*/_jsx(HighlightedCodeWithTabs, {
      tabs: renderedMarkdownOrDemo.data,
      storageKey: renderedMarkdownOrDemo.storageKey && "codeblock-".concat(renderedMarkdownOrDemo.storageKey)
    });
  }
  var name = renderedMarkdownOrDemo.demo;
  var demo = demos == null ? void 0 : demos[name];
  if (demo === undefined) {
    var errorMessage = ["Missing demo: ".concat(name, ". You can use one of the following:"), Object.keys(demos)].join('\n');
    if (userLanguage === 'en') {
      throw new Error(errorMessage);
    }
    if (false) {
      console.error(errorMessage);
    }
    var warnIcon = /*#__PURE__*/_jsx("span", {
      role: "img",
      "aria-label": t('emojiWarning'),
      children: "\u26A0\uFE0F"
    });
    return /*#__PURE__*/_jsxs("div", {
      children: [warnIcon, " Missing demo `", name, "` ", warnIcon]
    });
  }
  var splitLocationBySlash = localizedDoc.location.split('/');
  splitLocationBySlash.pop();
  var fileNameWithLocation = "".concat(splitLocationBySlash.join('/'), "/").concat(name);
  return /*#__PURE__*/_jsx(Demo, {
    demo: {
      raw: demo.raw,
      js: (_demoComponents$demo$ = demoComponents[demo.module]) != null ? _demoComponents$demo$ : noComponent(demo.module),
      scope: demos.scope,
      jsxPreview: demo.jsxPreview,
      tailwindJsxPreview: demo.tailwindJsxPreview,
      cssJsxPreview: demo.cssJsxPreview,
      rawTS: demo.rawTS,
      module: demo.module,
      moduleTS: demo.moduleTS,
      tsx: (_demoComponents$demo$2 = demoComponents[demo.moduleTS]) != null ? _demoComponents$demo$2 : noComponent(demo.moduleTS),
      rawTailwind: demo.rawTailwind,
      rawTailwindTS: demo.rawTailwindTS,
      jsTailwind: (_demoComponents$demo$3 = demoComponents[demo.moduleTailwind]) != null ? _demoComponents$demo$3 : null,
      tsxTailwind: (_demoComponents$demo$4 = demoComponents[demo.moduleTSTailwind]) != null ? _demoComponents$demo$4 : null,
      rawCSS: demo.rawCSS,
      rawCSSTS: demo.rawCSSTS,
      jsCSS: (_demoComponents$demo$5 = demoComponents[demo.moduleCSS]) != null ? _demoComponents$demo$5 : null,
      tsxCSS: (_demoComponents$demo$6 = demoComponents[demo.moduleTSCSS]) != null ? _demoComponents$demo$6 : null,
      gaLabel: fileNameWithLocation.replace(/^\/docs\/data\//, ''),
      relativeModules: demo.relativeModules
    },
    disableAd: disableAd,
    demoOptions: renderedMarkdownOrDemo,
    githubLocation: "".concat(process.env.SOURCE_CODE_REPO, "/blob/v").concat(process.env.LIB_VERSION).concat(fileNameWithLocation)
  });
}
false ? void 0 : void 0;